<template>
  <section class="activity-log">
    <context-state :state="state">
      <template v-slot:loading>
        Carregando atividades...
      </template>

      <template v-slot:notfound>
        Atividades não encontradas :(
      </template>
    </context-state>

    <ul
      v-for="(log, index) in filteredActivity"
      :key="log.id"
      class="activity-log-items"
    >
      <information-line
        :value="created(log.created_at)"
        class="activity-log-item"
        :copiable="false"
      >
        <template v-slot:label>
          <b class="activity-log-user">
            {{ seller(log.user) }}
          </b>

          <span class="activity-log-item-span">{{ sdk.mobile ? '' : activities(log) }}</span>
        </template>
      </information-line>

      <information-line
        v-if="sdk.mobile"
        :label="activities(log)"
        valueless
        class="activity-log-details"
        :copiable="false"
      />

      <span
        v-if="index !== filteredActivity.length - 1"
        class="read-separator-log"
      />
    </ul>
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  import ContextState from '@cordel/components/Context/State.vue';
  import InformationLine from '@cordel/components/Information/Line.vue';
  import status from '@cordel/helpers/colors/proposals';

  import mobile from '@sdk/helpers/interface/mobile';
  import namelize from '@sdk/helpers/formatters/namelize';
  import dateize from '@sdk/helpers/formatters/dateize';

  import itensLogs from './logs';

  export default {
    name: 'ReadLog',
    components: {
      ContextState,
      InformationLine,
    },
    mixins: [
      mobile,
    ],
    props: {
      parent: {
        type: String,
        default: null,
      },
    },
    computed: {
      ...mapState([
        'proposals',
        'customers',
      ]),

      state() {
        if (this.loading) {
          return 'loading';
        }

        if (!this.activity.length || this.createActivity.length === this.activity.length) {
          return 'notfound';
        }

        return null;
      },

      key() {
        return this.parent === 'logProposals' ? 'proposals' : 'customers';
      },
      loading() {
        return this[this.key].activityLog.loading;
      },
      activity() {
        return this[this.key].activityLog.items || [];
      },
      filteredActivity() {
        return this
          .activity
          .filter(log => log.event !== 'create');
      },
      createActivity() {
        return this.activity.filter(log => log.event === 'create');
      },
    },
    mounted() {
      const key = this.parent === 'logProposals' ? 'proposals' : 'customers';

      this.$store.dispatch(`${key}/activity_log`, {
        id: this[key].read.item.id,
      });
    },
    methods: {
      seller(user) {
        if (!user || !user.name) {
          return 'O Banco';
        }

        return namelize(user.name);
      },
      created(date) {
        if (!date) {
          return '';
        }

        return dateize(date, { output: 'DD/MM/YY - HH[h]mm' });
      },
      activities(item) {
        const {
          event,
          item_changes: itemChanges,
          item_type: itemType,
          item_id: itemID,
        } = item;

        const keys = Object.keys(itemChanges);
        let message = '';

        if (keys[0] === 'state') {
          let [oldStatus, newStatus] = itemChanges.state;

          oldStatus = oldStatus ? (itensLogs[oldStatus] || oldStatus) : null;
          newStatus = itensLogs[newStatus] || newStatus;

          oldStatus = (status(oldStatus) || oldStatus).toLowerCase();
          newStatus = (status(newStatus) || newStatus).toLowerCase();

          message += `Alterou o status de "${oldStatus || 'vazio'}" para "${newStatus}"`;
        } else {
          if (itemChanges.owner_id && this.parent === 'logProposals') {
            message += 'Reivindicou a responsabilidade desta proposta. '; // DO NOT TRIM WHITE SPACE!
          }

          if (keys.filter(i => i !== 'owner_id').length > 0) {
            const formattedKeys = keys
              .filter(i => i !== 'owner_id')
              .map((key) => {
                if (itensLogs[itemType] && itensLogs[itemType][key]) {
                  return itensLogs[itemType][key];
                }

                if (itensLogs[key]) {
                  return itensLogs[key];
                }

                return key;
              });

            message += `${event === 'update' ? 'Alterou' : 'Removeu'}: ${formattedKeys.join(', ')}`;
          }
        }

        if (itemID) {
          message += ` (id: ${itemID})`;
        }

        return message;
      },
    },
  };
</script>

<style lang="scss">
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .activity-log-item {
    .cordel-information-line-label {
      display: flex;
      flex-direction: row;
    }

    .cordel-information-line-value-raw {
      margin-left: var(--cordel-legacy-spacing-giga);
      white-space: nowrap;
    }

    .cordel-information-line {
      align-items: center;
    }
  }

</style>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .activity-log {
    margin-top: var(--cordel-legacy-spacing-blaster);
  }

  .activity-log-items {
    list-style: none;
    margin: 0;
  }

  .activity-log-item-span {
    margin-left: var(--cordel-legacy-spacing-xxxs);
    flex: 1;
  }

  .read-separator-log {
    background-color: var(--cordel-legacy-color-neutral-light);
    display: block;
    height: var(--cordel-legacy-border-width-soft);
    margin: var(--cordel-legacy-spacing-mini) 0 var(--cordel-legacy-spacing-mini);
  }

  .activity-log-user {
    font-weight: var(--cordel-legacy-font-weight-bold);
    white-space: nowrap;
  }
</style>
